import gql from 'graphql-tag';

export default () => gql`
  query {
    getConfigSreserved(dummy: "") {
      configSreservedList{
        value
        description
      }
    }
  }
`;
